import { dictFromArray, type Dictionary, dictMap } from './dictionary.no-deps'
import { pipe } from './pipe.no-deps'

/** Helper to create tuples that aren't readonly */
export const tuple = <T extends any[]>(...ts: T): T => ts

export function fst<Tuple extends any[]>(tuple: Tuple): Tuple[0] {
    return tuple[0]
}

export function snd<Tuple extends any[]>(tuple: Tuple): Tuple[1] {
    return tuple[1]
}

type Tail<Tuple extends any[]> = Tuple extends [infer _, ...infer Rest] ? Rest : never

export function tail<Tuple extends any[]>(tuple: Tuple): Tail<Tuple> {
    const [, ...rest] = tuple
    return rest as Tail<Tuple>
}

export function mapFirst<Tuple extends any[], T2>(fn: (t: Tuple[0]) => T2) {
    return (tuple: Tuple): [T2, ...Tail<Tuple>] => {
        // @ts-ignore https://github.com/microsoft/TypeScript/issues/39713
        return [fn(fst(tuple)), tail(tuple)]
    }
}

export function arrayOfTuplesToDictionary<T1 extends string, T2>(tupleArray: Array<[T1, T2]>): Dictionary<T2> {
    return pipe(dictFromArray(tupleArray, fst), (d) => dictMap(d, snd))
}
